import React from 'react';
import styled from 'react-emotion';
import Image from '@jetshop/ui/Image';

const ImageWrapper = styled('div')`
  background: #fff;
  text-align: center;
  position: relative;
  min-width: 625px;
  //img {
  //  position: absolute;
  //  top: 50%;
  //  transform: translateX(-50%) translateY(-50%);
  //  left: 50%;
  //  max-width: 100%;
  //  max-height: 100%;
  //  width: auto;
  //  height: auto;
  //}
`;

const Fullsize = ({ image, onClick }) => {
  return image ? (
    <ImageWrapper>
      {/*<img onClick={onClick} src={image.url} alt={image.url} />*/}
      <Image
        src={image.url}
        alt={'altttt'}
        sizes={[625]}
        critical={false}
        aspect={'1:1'}
      />
    </ImageWrapper>
  ) : null;
};

export default Fullsize;
